<template>
  <div v-if="loading" class="e-skeleton">
    <div
      v-for="n in widths.length"
      :key="n"
      class="e-skeleton__line"
      :style="{ width: getWidth(n - 1), height: lineHeight }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ESkeleton',
  props: {
    loading: { type: Boolean, default: true },
    count: { type: Number, default: 3 }, // 라인 개수
    widths: { type: Array, default: () => ['100%', '80%', '60%'] }, // 라인별 폭
    lineHeight: { type: String, default: '12px' }
  },
  methods: {
    getWidth (i) {
      return this.widths[i % this.widths.length]
    }
  }
}
</script>

<style scoped>
.e-skeleton {
  padding: 12px 0;
}
.e-skeleton__line {
  background: linear-gradient(
    90deg,
    #f0f0f0 0%,
    #e4e4e4 50%,
    #f0f0f0 100%
  );
  background-size: 200% 100%;
  animation: e-skeleton-shimmer 1.4s ease-in-out infinite;
  border-radius: 4px;
  margin-bottom: 8px;
}
.e-skeleton__line:last-child {
  margin-bottom: 0;
}
@keyframes e-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
